export SignUpForm from './SignUpForm';
export SignInForm from './SignInForm';
export ResetFormEmail from './ResetFormEmail';
export ResetFormPassword from './ResetFormPassword';
export Base from './Base';



// WEBPACK FOOTER //
// ./src/modules/auth/containers/index.js